<template>
    <div class="container">
        <div class="commerce-items-section" :class="'commerce-items-section-' + commerceListView">
            <div class="commerce-item" v-for="item in commerceItems" :class="'commerce-view-' + commerceListView">
                <router-link :to="{ name: 'commerce-card' , params:{'id' : item.id}}">
                    <div class="item-content-grid" v-if="commerceListView == 'grid'"> 
                        <div class="item-img">
                            <img :src="item.images[0]" alt="" v-if="item.images != false && item.images.length > 0">
                            <svgIcon name="none-img" class="icon-none-img" v-else/>
                        </div>
                        <div class="item-info">
                            <h3>{{ item.name }}</h3>
                            <p v-html="item.adres"></p>
                            <div class="rent-info" v-if="item.rent == 'true'">
                                <div class="info-label">{{ filterCMSparams.words_translation.rent }} - </div>
                                <div class="info-value size-value">{{ getNumber(item.rent_price) }} <span>тг</span></div>
                            </div>
                            <div class="item-bottom">
                                <div class="info-value">{{ item.size }} <span>м²</span></div>
                                <div class="info-value price-value">{{ getNumber(item.price_full) }} тг</div>
                            </div>
                        </div>
                    </div>
                    <div class="item-head-mobile" v-if="commerceListView == 'list' && isMobileChecker">
                        <div class="info-value info-value-price">{{ getNumber(item.price_full) }} тг</div>
                        <div class="info-value">{{ item.project.name }}</div>
                        <div class="info-value info-value-part">{{ parseInt(item.part.label) }} {{ filterCMSparams.words_translation.part }}</div>
                        <div class="info-value info-value-rent" v-if="item.rent == 'true'">{{ filterCMSparams.words_translation.rent }} - {{getNumber(item.rent_price) }} тг</div>
                    </div>
                    <div class="item-content-list" v-if="commerceListView == 'list'">
                        <ul>
                            <li v-if="!isMobileChecker">
                                <div class="item-img">
                                    <img :src="item.images[0]" alt="" v-if="item.images != false && item.images.length > 0">
                                    <svgIcon name="none-img" class="icon-none-img" v-else/>
                                </div>
                            </li>
                            <li v-if="!isMobileChecker">
                                <div class="info-value info-value-project">{{ item.project.name }}</div>
                            </li>
                            <li v-if="!isMobileChecker">
                                <div class="info-value">{{ parseInt(item.part.label) }}</div>
                            </li>
                            <!-- <li :class="{'empty' : item.type == false}">
                                <div class="info-value type-value">{{ item.type.name }}</div>
                            </li> -->
                            <li>
                                <div class="info-value">{{ formatArray(item.level) }} <span v-if="isMobileChecker">ур.</span></div>
                            </li>
                            <li>
                                <div class="info-value size-value">{{ item.size }} <span v-if="isMobileChecker">м²</span></div>
                            </li>
                            <li v-if="!isMobileChecker">
                                <div class="info-value price-value">{{ getNumber(item.price_full) }} тг</div>
                            </li>
                        </ul>
                    </div>
                    <div class="favorite-item" :class="{'change-color' : item.images != false && item.images.length > 0}">
                        <div class="btn-link" @click.prevent="sendToFavorite(item), toogleActiveClass($event)" :class="{'active' : checkIfFavorite(item)}">
                            <svgIcon name="favorite-disactive" class="icon-favorite"/>
                            <svgIcon name="favorite-active" class="icon-favorite-active"/>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'commerce-items-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            // indexPage: 'loadIndexPage',
            filterCMSparams: 'loadFilterCMSparams',
            commerceItems: 'loadCommerceItems',
            commerceItemsAnimate: 'loadCommerceItemsAnimate',
            isMobileChecker: 'loadIsMobileChecker',
            commerceListView: 'loadCommerceListView',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            sendToFavorite(arr) {
                // console.log(arr)
                var favorites = JSON.parse(localStorage.getItem('favorite_commerce_dial')) || [];
                var finder = this.checkIfFavorite(arr); // проверка наличия объекта в массиве избранных
                if (!finder) { // Добавляем объект в массив если такого объекта не обнаружено в массиве
                    favorites.push(arr);
                    localStorage.setItem('favorite_commerce_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                } else { // Убираем из массива если такой объект уже есть в избранном
                    favorites = favorites.filter(favorite => favorite.id != arr.id);
                    localStorage.setItem('favorite_commerce_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                    // console.log(favorites, 'asdasdasdasdasd')
                }
            },
            checkIfFavorite(arr) { // проверка наличия объекта в массиве избранных
                var favorites = JSON.parse(localStorage.getItem('favorite_commerce_dial')) || [];
                var finder = favorites.some(favorite => favorite.id === arr.id); 
                return finder;
            },
            toogleActiveClass(event) {
                event.currentTarget.classList.toggle('active');
            },
            formatArray(arr) {
                if (!Array.isArray(arr) || arr.length === 0) {
                    return ""; // Возвращаем пустую строку, если массив пустой
                }
                return arr.join(", ");
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/commerce-page/commerce-items.scss';
    @import '@/styles/components/commerce-page/respond/commerce-items-respond.scss';
</style>